import { forwardRef, HTMLAttributes } from 'react';

import classNames from 'classnames';

import styles from './tooltip-card.module.scss';

/** Shared bubble skin, including chart adapters. */
const TooltipCard = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={classNames(styles.card, className)} {...props} />
  ),
);

export { TooltipCard };
